import React, { Component } from 'react';
// import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
//import NewVenue from 'components/AddNewVenue/AddNewVenue';
import NewVenueV2 from 'components/AddNewVenue/AddNewVenueV2';
import { GoogleApiWrapper } from 'google-maps-react';
import axios from 'axios';
//import { user_entity_uuid, user_access_level, apiUrl, myHeaders_Autorized, channel_list_api, venues_api, myHeaders_With_Cache_Control, HeaderConfig, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import { org_friendly_url, apiUrl, myHeaders_With_Cache_Control } from "Api/Api";
// , myHeaders_Autorized, channel_list_api, venues_api, user_access_level
import 'pages/City/style.css';
//import _get from 'lodash/get';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { local_routes } from 'utils/Routes';

let imgTempArr = [];
// let particularCityData=null;
let formExistingData=null
class WorkspaceVenues extends Component {
    constructor(props) {
        super(props)
        this.state = {
            venues_array: [],
            selected_venue_index: 0,
            loading: true,
            message: '',
            error_message: '',
        };

        
        this.workspace_base_url = "";
        if (org_friendly_url) {
            this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        
    }

    componentDidMount = async function () {
        await this.APICalls({});
    }

    APICalls = async (config) => {
        let new_state = {...this.state};
        
        let [venues_response] = await Promise.all([
            axios.get(`${apiUrl}organizations/${this.props.org_data.entity_uuid}/venues`, myHeaders_With_Cache_Control)
        ]);
        
        new_state.venues_array = venues_response.data;
        new_state.venues_array = new_state.venues_array.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
        new_state.venues_array.unshift({entity_uuid:'',entity_name:'(None)'});

        if (config.selected_venue_uuid) {
            // a little tricky because of sorting by name
            for (let i = 0; i < new_state.venues_array.length; i++) {
                if (new_state.venues_array[i].entity_uuid === config.selected_venue_uuid) {
                    new_state.selected_venue_index = i;
                }
            }
        } else {
            new_state.selected_venue_index = 0;
        }
        
        if (config.message) {
            new_state.message = config.message;
        } else {
            new_state.message = "";
        }
        if (config.error_message) {
            new_state.error_message = config.error_message;
        } else {
            new_state.error_message = "";
        }
        new_state.loading = false;
        
        this.setState( new_state );
    }
    
    onSaveVenue = async (venue_info) => {
        if (venue_info === false) {
            // cancel
            this.setState({
                message: '',
                error_message: 'Canceled',
                selected_venue_index: 0,
                showEditComponent: false
            });
            return;
        }
        
        this.setState({
            loading: true,
            showEditComponent: false
        });
        
        let message = "";
        let error_message = "";
        
        let tmp_venue_info = {...venue_info};
        tmp_venue_info.friendly_url = tmp_venue_info.entity_name.toLowerCase().replace(/ /g, "-");

        // if we have entity_uuid it would be blank...remove it
        delete tmp_venue_info.entity_uuid;
        
        if (venue_info.entity_uuid) {
            // EDIT / patch
            await axios.patch(`${apiUrl}venues/${venue_info.entity_uuid}`, tmp_venue_info);
            message = "Venue successfully edited";
        } else {
            // CREATE / post
            let add_venue_response = await axios.post(`${apiUrl}venues`, tmp_venue_info);
            if (add_venue_response.data.entity_uuid) {
                venue_info.entity_uuid = add_venue_response.data.entity_uuid;
                message = "Venue successfully added";
            } else {
                // problem!
                venue_info.entity_uuid = "";
                error_message = "Problem adding venue";
            }
        }
        
        //this.APICalls({message,selected_venue_uuid:venue_info.entity_uuid});
        this.APICalls({message,error_message});
    }
    
    // For handling venue change
    venueChangeHandler = (event) => {
        console.log("WorkspaceVenues venueChangeHandler",event.target.value);
        this.setState({
            message: '',
            error_message: '',
            showEditComponent: (event.target.value !== '0'), // '(None)'
            selected_venue_index: parseInt(event.target.value)
        });
    }
    
    onClickShowAddVenue = () => {
        this.setState({
            message: '',
            error_message: '',
            showEditComponent: true,
            selected_venue_index: 0 // blank info except entity_name
        });
    }
    
    render() {
        //const { VenuesuccessMsg, venueData, loading,editVenueStatus, showComponent, venue_name,showEditComponent, venue_uuid ,particularCityData} = this.state;
        // eslint-disable-next-line
        
        if (this.state.loading) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            );
        }
        //console.log("RENDER",this.state.venues_array[this.state.selected_venue_index].entity_name);

            return (
                <div className="venue eventCreation">
 
                    {/* <Form onSubmit={this.handleSubmitDescriptionData}> */}
                    { (!this.state.showEditComponent || (this.state.showEditComponent && this.state.selected_venue_index !== 0)) &&
                        <Form.Row className="align-items-center">
                            <Form.Group as={Col} md="6" controlId="validationPkTitle" className="venueAlign" style={{marginTop: "20px"}}>
                                <span className="d-flex justify-content-between align-items-center">
                                    <Form.Label>Edit Existing Venue</Form.Label>
                                </span>
                                <Form.Control
                                    disabled={this.state.showEditComponent}
                                    as="select"
                                    //required
                                    //value={this.state.venues_array[this.state.selected_venue_index].entity_name}
                                    value={this.state.selected_venue_index}
                                    onChange={this.venueChangeHandler}
                                >
                                    {
                                        this.state.venues_array.map((item,i) =>
                                            <option key={item.entity_uuid} value={i}>{item.entity_name}</option>
                                        )
                                    }
                                </Form.Control>
                            </Form.Group>
                        </Form.Row>
                    }
                    { this.state.message &&
                        <p style={{color:'green',fontSize:12}}>{this.state.message}</p>
                    }
                    { this.state.error_message &&
                        <p style={{color:'red',fontSize:12}}>{this.state.error_message}</p>
                    }
                    { !this.state.showEditComponent &&
                        <h6 onClick={this.onClickShowAddVenue}>+ Add New Venue</h6>
                    }
                    
                    {/* </Form> */}
                    { this.state.showEditComponent &&
                        <div style={{ paddingTop: "10px" }}>
                            
                                <NewVenueV2
                                    venue_info={this.state.venues_array[this.state.selected_venue_index]}
                                    onSaveVenue={this.onSaveVenue}
                                />
                            
                            
                        </div>
                    }
                </div>
            );
    }
}
export default GoogleApiWrapper({
    apiKey: 'AIzaSyATS36RdvbWd9ESucCYIVvzqIxj3EFbQcg'
})(WorkspaceVenues);
